import { useMutation } from "react-query"

import axios from "axios"

import { MemberOptInResponse, ServiceFailedToReturn, FailureMessage } from "./types"
import { optinPostPath } from "./utils"

export const useMemberOptin = (onSuccess: () => void) => {
  const apiCall = async (memberUuid: string) => {
    try {
      const { data } = await axios.post(
        optinPostPath(memberUuid),
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: (status: number) => status === 200,
        },
      )

      onSuccess()

      return data
    } catch (err: any) {
      return {
        failureMessage: FailureMessage.OPERATION_ERROR,
      }
    }
  }

  return useMutation<
    MemberOptInResponse & ServiceFailedToReturn,
    { message: string },
    string
  >(apiCall)
}
